// Intercept all alert() calls and replace them with a custom alert box
document.addEventListener("DOMContentLoaded", function () {
    (function () {
        // Create modal elements
        const alertBackdrop = document.createElement('div');
        alertBackdrop.className = 'custom-alert-backdrop';
        // moved all the css here tp get rid of floating ok button in admin panel
        Object.assign(alertBackdrop.style, {
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: '9999',
            backdropFilter: 'blur(1px)',
        });

        const alertBox = document.createElement('div');
        alertBox.className = 'custom-alert-box';
        Object.assign(alertBox.style, {
            background: '#eee',
            borderRadius: '3px',
            padding: '1.5rem',
            maxWidth: '95%',
            width: '400px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
            textAlign: 'center',
        });

        const alertMessage = document.createElement('div');
        alertMessage.className = 'custom-alert-message';
        Object.assign(alertMessage.style, {
            marginBottom: '1.5rem',
            fontSize: '1rem',
            color: '#333',
        });

        const alertButton = document.createElement('button');
        alertButton.className = 'custom-alert-button';
        alertButton.textContent = 'OK';
        Object.assign(alertButton.style, {
            background: '#0a97b9',
            color: '#fff',
            fontFamily: 'arial',
            fontSize: '.73rem',
            fontWeight: '700',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            border: '2px solid #0a97b9',
            lineHeight: '1rem',
            padding: '.5rem 1rem',
            transition: 'all .3s ease-in-out',
        });

        alertBox.appendChild(alertMessage);
        alertBox.appendChild(alertButton);
        alertBackdrop.appendChild(alertBox);
        document.body.appendChild(alertBackdrop);

        // Show/hide logic
        function showCustomAlert(message) {
            alertMessage.textContent = message;
            alertBackdrop.style.display = 'flex';
            alertBox.animate(
                [
                    { opacity: 0, transform: 'scale(0.9)' },
                    { opacity: 1, transform: 'scale(1)' },
                ],
                { duration: 250, easing: 'ease' }
            );

            return new Promise((resolve) => {
                alertButton.onclick = () => {
                    alertBackdrop.style.display = 'none';
                    resolve();
                };
            });
        }

        // Override native alert
        window.alert = async function (message) {
            await showCustomAlert(message);
        };
    })();
});
